import {PayloadAction, createSlice} from "@reduxjs/toolkit";

export const AuthScreenStatus = {
    PHONE: 'PHONE',
    OTP: 'OTP',
    PIN: 'PIN',
    CREATE_PIN: 'CREATE_PIN',
    WHO_ARE_YOU: 'WHO_ARE_YOU'
} as const;

type AuthScreenStatus = typeof AuthScreenStatus[keyof typeof AuthScreenStatus];

const initialState: AuthSliceState = {
    status: AuthScreenStatus.PHONE,
};

export interface AuthSliceState {
    status: AuthScreenStatus;
}

function _init() {
}

function _setState(state: AuthSliceState, payload: AuthScreenStatus) {
    state.status = payload;
}

export const authSlice = createSlice({
    name: "auth",
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        init: (state) => {
            _init();
        },
        setState: (state, action: PayloadAction<AuthScreenStatus>) => {
            state.status = action.payload;
        },
    },
    // You can define your selectors here. These selectors receive the slice
    // state as their first argument.
    selectors: {
        selectStatus: (counter) => counter.status,
    },
});

// Action creators are generated for each case reducer function.
export const {init, setState} =
    authSlice.actions;

// Selectors returned by `slice.selectors` take the root state as their first argument.
export const {selectStatus} = authSlice.selectors;

export const selectAuthStatus = (state: { auth: AuthSliceState }) => state.auth.status;